import React, { useEffect, useState } from "react";
import { getPerformance } from "../services/api.js";

export default function PerformanceSummary({ period='month' }){
  const [stats, setStats] = useState({});

  useEffect(()=>{ (async()=>{ setStats(await getPerformance(period)); })(); },[period]);

  return (
    <div className="card">
      <div className="font-semibold mb-2">Performance ({period})</div>
      <div className="grid grid-cols-2 gap-2 text-sm">
        <div>Trades</div><div className="text-right">{stats.count||0}</div>
        <div>Trefferquote</div><div className="text-right">{((stats.hit_rate||0)*100).toFixed(1)}%</div>
        <div>Ø P&L</div><div className="text-right">{(stats.avg_pnl||0).toFixed(2)} €</div>
        <div>Total P&L</div><div className="text-right">{(stats.total_pnl||0).toFixed(2)} €</div>
      </div>
    </div>
  );
}